import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconDownloadLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 15.412a.83.83 0 0 1-.633-.256l-3.11-3.11a.706.706 0 0 1-.22-.522.77.77 0 0 1 .22-.532.765.765 0 0 1 .535-.24c.202-.005.38.07.535.225L11.25 12.9V5.25c0-.213.072-.391.216-.535A.725.725 0 0 1 12 4.5c.213 0 .391.072.534.215a.725.725 0 0 1 .216.535v7.65l1.923-1.923a.714.714 0 0 1 .53-.22c.204.002.384.08.54.235.144.155.22.331.224.527a.7.7 0 0 1-.225.527l-3.11 3.11a.83.83 0 0 1-.632.255ZM6.308 19.5c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 0 1-.525-1.283v-1.961a.73.73 0 0 1 .215-.535.725.725 0 0 1 .535-.215.73.73 0 0 1 .535.215.726.726 0 0 1 .215.535v1.961c0 .077.032.148.096.212a.294.294 0 0 0 .212.096h11.384a.294.294 0 0 0 .212-.096.294.294 0 0 0 .096-.212v-1.961a.73.73 0 0 1 .215-.535.725.725 0 0 1 .535-.215.73.73 0 0 1 .535.215.725.725 0 0 1 .215.535v1.961c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H6.308Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconDownloadLine;
